module.exports = __webpack_public_path__ + "img/linkedin.d03e560d.svg";